import React from "react";
import Whatsapp from "react-whatsapp"
// hooks
import {useAcfAboutUs} from "../../hooks/useAcfAboutUs";
// constants
import {contactFormAcf} from "../../constants/acf";
import './style.css';

export default function ContactUs() {
    const acf = useAcfAboutUs(contactFormAcf);
    const whatsapp = acf['contact-form-call-whatsapp'] && acf['contact-form-call-whatsapp'].trim();
    return (
        <div className="n-contact-us">
            <div className="n-contact-us__row n-contact-us__row--title">
                <h2> {acf['contact-form-title'] || 'Contact Us'} </h2>
                <p className="n-contact-us__paragraph">
                    {acf['contact-form-description']}
                </p>
            </div>

            <div className="n-contact-us__row">
                <h5>Call or Whatsapp:</h5>
                {whatsapp ?
                    <Whatsapp number={acf['contact-form-call-whatsapp']}>
                        <span className="n-contact-us__value">
                            {acf['contact-form-call-whatsapp']}
                        </span>
                    </Whatsapp>
                : null }

            </div>
            <div className="n-contact-us__row">
                <h5>Email us:</h5>
                <a href={`mailto:${acf['contact-form-email-us']}`}
                   className="n-contact-us__value">{acf['contact-form-email-us']}</a>
            </div>
            <div className="n-contact-us__row">
                <h5>Working hours:</h5>
                <span className="n-contact-us__value">{acf['contact-form-working-hours-working-days']}</span>
                <span className="n-contact-us__value">{acf['contact-form-working-hours-working-saturday']}</span>
                <span className="n-contact-us__value">{acf['contact-form-working-hours-working-sunday']}</span>
            </div>
            <div className="n-contact-us__row">
                <h5>Visit us:</h5>
                <span className="n-contact-us__value">120 Lower Delta Road,</span>
                <span className="n-contact-us__value">08-01/02 Cendex Centre,</span>
                <span className="n-contact-us__value">169208</span>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/new-components/contact-us/index.js